import { defineComponent } from 'vue'

import { getTranslatedString } from '@skinsoft/types'
import { thesaurusTermSelectors } from '@skinsoft/selectors'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'

export const ThesaurusTermView = defineComponent({
    mixins: [reactiveVueMixin],
    components: {

    },
    props: {
        thesaurusTermId: { type: String, required: true },
    },
    template: require('./thesaurus-term-view.html'),
    data() {
        return {
            term: "",
        }
    },
    methods: {
        subscribe() {
            const locale = this.getAppLocale();
            this.subscribeTo(
                this.$thesaurusTermDataStore.fetchOne(this.thesaurusTermId),
                thesaurusTerm => {
                    this.term = getTranslatedString(thesaurusTermSelectors.preferredTerm(thesaurusTerm), locale)
                },
                'term-subscription')
        },
    },
    watch: {
        thesaurusTermId: {
            handler() {
                this.unsubscribeFrom('term-subscription');
                if (this.thesaurusTermId) {
                    this.subscribe()
                }
            },
            immediate: true,
        },
    },
})
